import { getLocale } from "@utils/i18n";
import { PRODUCT_TYPES } from "../data";
import type { StepValues } from "../type";
import type { PartnerOfficeLeadRequest } from "./type";

export const mapStepValuesToLeadRequest = (values: StepValues, consultantId: string): PartnerOfficeLeadRequest => {
	const { "lead-form": leadFormStep } = values;

	return {
		request: {
			otherData: `Miről szeretnél többet megtudni: ${PRODUCT_TYPES[leadFormStep.productType]?.label ?? "Ismeretlen termék"}`,
			question: leadFormStep.question,
		},
		response: {},
		calculatorType: "PERSONAL_MEETING",
		source: "BM",
		firstName: leadFormStep.firstName,
		lastName: leadFormStep.lastName,
		email: leadFormStep.email,
		phone: leadFormStep.phone,
		calculatorLang: getLocale(),
		calculationData: "",
		consultant: consultantId,
	};
};
